<template>
<nav class="bg-primary-500 flex flex-col md:flex-row p-4 sm:text-base md:text-lg fixed top-0 left-0 right-0 shadow-md z-50">
  <div class="w-full flex sm:justify-normal md:justify-between items-center"> 
    <button class="sm:visible md:hidden text-white" @click="ShowMenu =! ShowMenu">
      <!-- Menu open: "hidden", Menu closed: "block" -->
      <svg class="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
      </svg>
      <!-- Menu open: "block", Menu closed: "hidden" -->
      <svg class="hidden h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>

    <router-link class="" to="/">
      <img class="sm:ml-5 md:ml-10 w-fit h-10" src="@/assets/image/logo_2.png" alt="Logo">
    </router-link>

    <div class="hidden md:flex space-x-4">
      <div class="relative inline-block text-left text-lg">
          <n-dropdown
              trigger="hover"
              placement="bottom-start"
              :options="options"
              @select="handleSelect"
          >
          <div>
              <button type="button" class="text-white rounded-md px-3 py-2  font-medium inline-flex justify-center w-full    hover:bg-blackmask-500 " @click="onTop">
                  {{ $t('MenuItem.About') }}
                  <svg class="w-5 h-5 ml-2 -mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 11.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                  </svg>
              </button>
          </div>
          </n-dropdown>
      </div>
      <router-link class="text-white rounded-md px-3 py-2  font-medium hover:bg-blackmask-500 " to="/product" @click="onTop">{{ $t('MenuItem.Production') }}</router-link>
      <router-link class="text-white rounded-md px-3 py-2  font-medium hover:bg-blackmask-500 " to="/patient" @click="onTop">{{ $t('MenuItem.Patient') }}</router-link>
      <div class="text-gray-100 hover:bg-blackmask-500 hover:text-white block rounded-md px-3 py-2  font-medium cursor-pointer" @click="onNews()"> {{ $t('MenuItem.News') }}</div>
      <router-link class="text-white rounded-md px-3 py-2  font-medium hover:bg-blackmask-500 " to="/job" @click="onTop">{{ $t('MenuItem.Jobs') }}</router-link>
      <router-link class="text-white rounded-md px-3 py-2  font-medium hover:bg-blackmask-500 " to="/investor">{{ $t('MenuItem.Intevtor') }}</router-link>
      <router-link class="text-white rounded-md px-3 py-2  font-medium hover:bg-blackmask-500 " to="/contact" @click="onTop">{{ $t('MenuItem.Contact') }}</router-link>     
      <div class="flex flex-row items-center justify-center text-lg pr-3">
          <n-dropdown
              trigger="click"
              placement="bottom"
              :options="optionsLang"
              @select="handleChangeLanguage"
          >
          <div>
              <button type="button" class="flex flex-row  items-center justify-center text-white rounded-md    hover:bg-blackmask-500 pr-5">
                <svg class="w-5 h-5 " xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512"><path d="M340.75 344.49c5.91-20.7 9.82-44.75 11.31-67.84a4.41 4.41 0 0 0-4.46-4.65h-71.06a4.43 4.43 0 0 0-4.47 4.39v55.3a4.44 4.44 0 0 0 4.14 4.38a273.51 273.51 0 0 1 59 11.39a4.45 4.45 0 0 0 5.54-2.97z" fill="currentColor"></path><path d="M323.58 377.31a260.05 260.05 0 0 0-46.6-9.09a4.42 4.42 0 0 0-4.91 4.29v65.24a4.47 4.47 0 0 0 6.76 3.7c15.9-9.27 29-24.84 40.84-45.43c1.94-3.36 4.89-9.15 6.67-12.69a4.29 4.29 0 0 0-2.76-6.02z" fill="currentColor"></path><path d="M235.29 368.4a256.85 256.85 0 0 0-46.56 8.82c-2.64.76-3.75 4.4-2.55 6.79c1.79 3.56 4 8.11 5.89 11.51c13 23 26.84 37.5 41.24 45.93a4.47 4.47 0 0 0 6.76-3.7v-65.27a4.16 4.16 0 0 0-4.78-4.08z" fill="currentColor"></path><path d="M235.6 272h-71.06a4.41 4.41 0 0 0-4.46 4.64c1.48 23.06 5.37 47.16 11.26 67.84a4.46 4.46 0 0 0 5.59 3a272.2 272.2 0 0 1 59-11.36a4.44 4.44 0 0 0 4.15-4.38V276.4a4.43 4.43 0 0 0-4.48-4.4z" fill="currentColor"></path><path d="M277 143.78a235.8 235.8 0 0 0 46.5-9.14a4.3 4.3 0 0 0 2.76-6c-1.79-3.57-4.27-8.68-6.17-12.09c-12.29-22-26.14-37.35-41.24-46a4.48 4.48 0 0 0-6.76 3.7v65.23a4.43 4.43 0 0 0 4.91 4.3z" fill="currentColor"></path><path d="M276.54 240h71.06a4.39 4.39 0 0 0 4.46-4.58c-1.48-22.77-5.27-47.8-11.16-68.22a4.46 4.46 0 0 0-5.59-2.95c-19 5.74-38.79 10.43-59.09 12a4.4 4.4 0 0 0-4.15 4.32v55.11a4.4 4.4 0 0 0 4.47 4.32z" fill="currentColor"></path><path d="M233.31 70.56c-15.42 8.57-29.17 24.43-41.47 46.37c-1.91 3.41-4.19 8.11-6 11.67a4.31 4.31 0 0 0 2.76 6a225.42 225.42 0 0 0 46.54 9.17a4.43 4.43 0 0 0 4.91-4.29V74.26a4.49 4.49 0 0 0-6.74-3.7z" fill="currentColor"></path><path d="M235.92 176.26c-20.3-1.55-40.11-6.24-59.09-12a4.46 4.46 0 0 0-5.59 2.95c-5.89 20.42-9.68 45.45-11.16 68.22a4.39 4.39 0 0 0 4.46 4.58h71.06a4.4 4.4 0 0 0 4.47-4.34v-55.09a4.4 4.4 0 0 0-4.15-4.32z" fill="currentColor"></path><path d="M414.39 97.61A224 224 0 1 0 97.61 414.39A224 224 0 1 0 414.39 97.61zM176.6 430.85a219.08 219.08 0 0 1-12.48-19.66c-2-3.69-4.84-9.26-6.73-13.13a7.29 7.29 0 0 0-10.31-3.16c-4.3 2.41-10 5.72-14.13 8.43a147.29 147.29 0 0 1-23.57-22.43a248.83 248.83 0 0 1 30.41-18.36c1.86-1 2.77-2.14 2.18-4.18a374.8 374.8 0 0 1-14.09-82.17a4.36 4.36 0 0 0-4.3-4.17H66.84a2 2 0 0 1-2-1.7A98.28 98.28 0 0 1 64 256a96.27 96.27 0 0 1 .86-14.29a2 2 0 0 1 2-1.7h56.74c2.29 0 4.17-1.32 4.29-3.63a372.71 372.71 0 0 1 14-81.83a4.36 4.36 0 0 0-2.19-5.11a260.63 260.63 0 0 1-29.84-17.9a169.82 169.82 0 0 1 23.14-22.8c4.08 2.68 9.4 5.71 13.66 8.11a7.89 7.89 0 0 0 11-3.42c1.88-3.87 4-8.18 6.06-11.88a221.93 221.93 0 0 1 12.54-19.91A185 185 0 0 1 256 64c28.94 0 55.9 7 80.53 18.46a202.23 202.23 0 0 1 12 19c2.59 4.66 5.34 10.37 7.66 15.32a4.29 4.29 0 0 0 5.92 1.94c5.38-2.91 11.21-6.26 16.34-9.63a171.36 171.36 0 0 1 23.2 23a244.89 244.89 0 0 1-29.06 17.31a4.35 4.35 0 0 0-2.18 5.12a348.68 348.68 0 0 1 13.85 81.4a4.33 4.33 0 0 0 4.3 4.12l56.62-.07a2 2 0 0 1 2 1.7a117.46 117.46 0 0 1 0 28.62a2 2 0 0 1-2 1.72h-56.67a4.35 4.35 0 0 0-4.3 4.17a367.4 367.4 0 0 1-13.87 81.3a4.45 4.45 0 0 0 2.19 5.19c5 2.59 10.57 5.48 15.37 8.42s9.55 6.08 14.13 9.34a172.73 172.73 0 0 1-23 22.93c-2.44-1.61-5.34-3.44-7.84-4.94c-1.72-1-4.89-2.77-6.65-3.76c-3.82-2.14-7.88-.54-9.79 3.4s-4.83 9.59-6.87 13.25a212.42 212.42 0 0 1-12.35 19.53C310.91 442.37 284.94 448 256 448s-54.77-5.63-79.4-17.15z" fill="currentColor"></path></svg>
                <span class="ml-2 ">{{ lang.label }}</span>
              </button>
          </div>
          </n-dropdown>
      </div>


    </div>
        
  </div>
    
  <div v-if="ShowMenu" id="mobile-menu" @click="onExpand"  :class="{'hidden': !onExpand}" class="text-xs">
    <div class="space-y-1 px-2 pb-3 pt-2 sm:px-3">
      <router-link  to="/about" href="#" class="text-gray-100 hover:bg-blackmask-500 hover:text-white block rounded-md px-3 py-2  font-medium" @click="ShowMenu =! ShowMenu && onExpand" >{{ $t('MenuItem.Introduction') }}</router-link>
      <router-link  to="/member" href="#" class="text-gray-100 hover:bg-blackmask-500 hover:text-white block rounded-md px-3 py-2  font-medium" @click="ShowMenu =! ShowMenu && onExpand" >{{ $t('MenuItem.Member') }}</router-link>
      <router-link class="text-gray-100 hover:bg-blackmask-500 hover:text-white block rounded-md px-3 py-2  font-medium" to="/product" @click="ShowMenu =! ShowMenu && onExpand">{{ $t('MenuItem.Production') }}</router-link>
      <router-link class="text-gray-100 hover:bg-blackmask-500 hover:text-white block rounded-md px-3 py-2  font-medium " to="/patient" @click="ShowMenu =! ShowMenu && onExpand" >{{ $t('MenuItem.Patient') }}</router-link>
      <router-link class="text-gray-100 hover:bg-blackmask-500 hover:text-white block rounded-md px-3 py-2  font-medium" to="/" @click="ShowMenu =! ShowMenu && onExpand">{{ $t('MenuItem.News') }}</router-link>
      <router-link class="text-gray-100 hover:bg-blackmask-500 hover:text-white block rounded-md px-3 py-2  font-medium" to="/job" @click="ShowMenu =! ShowMenu && onExpand">{{ $t('MenuItem.Jobs') }}</router-link>
      <router-link class="text-gray-100 hover:bg-blackmask-500 hover:text-white block rounded-md px-3 py-2  font-medium" to="/investor" @click="ShowMenu =! ShowMenu && onExpand">{{ $t('MenuItem.Intevtor') }}</router-link>
      <router-link class="text-gray-100 hover:bg-blackmask-500 hover:text-white block rounded-md px-3 py-2  font-medium" to="/contact" @click="ShowMenu =! ShowMenu && onExpand">{{ $t('MenuItem.Contact') }}</router-link>
      <div class="flex flex-row items-center justify-center text-lg pr-3">
          <n-dropdown
              trigger="click"
              placement="bottom"
              :options="optionsLang"
              @select="handleChangeLanguage"
          >
          <div>
              <button type="button" class="text-base flex flex-row  items-center justify-center text-white rounded-md    hover:bg-blackmask-500 pr-5">
                <svg class="w-5 h-5 " xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512"><path d="M340.75 344.49c5.91-20.7 9.82-44.75 11.31-67.84a4.41 4.41 0 0 0-4.46-4.65h-71.06a4.43 4.43 0 0 0-4.47 4.39v55.3a4.44 4.44 0 0 0 4.14 4.38a273.51 273.51 0 0 1 59 11.39a4.45 4.45 0 0 0 5.54-2.97z" fill="currentColor"></path><path d="M323.58 377.31a260.05 260.05 0 0 0-46.6-9.09a4.42 4.42 0 0 0-4.91 4.29v65.24a4.47 4.47 0 0 0 6.76 3.7c15.9-9.27 29-24.84 40.84-45.43c1.94-3.36 4.89-9.15 6.67-12.69a4.29 4.29 0 0 0-2.76-6.02z" fill="currentColor"></path><path d="M235.29 368.4a256.85 256.85 0 0 0-46.56 8.82c-2.64.76-3.75 4.4-2.55 6.79c1.79 3.56 4 8.11 5.89 11.51c13 23 26.84 37.5 41.24 45.93a4.47 4.47 0 0 0 6.76-3.7v-65.27a4.16 4.16 0 0 0-4.78-4.08z" fill="currentColor"></path><path d="M235.6 272h-71.06a4.41 4.41 0 0 0-4.46 4.64c1.48 23.06 5.37 47.16 11.26 67.84a4.46 4.46 0 0 0 5.59 3a272.2 272.2 0 0 1 59-11.36a4.44 4.44 0 0 0 4.15-4.38V276.4a4.43 4.43 0 0 0-4.48-4.4z" fill="currentColor"></path><path d="M277 143.78a235.8 235.8 0 0 0 46.5-9.14a4.3 4.3 0 0 0 2.76-6c-1.79-3.57-4.27-8.68-6.17-12.09c-12.29-22-26.14-37.35-41.24-46a4.48 4.48 0 0 0-6.76 3.7v65.23a4.43 4.43 0 0 0 4.91 4.3z" fill="currentColor"></path><path d="M276.54 240h71.06a4.39 4.39 0 0 0 4.46-4.58c-1.48-22.77-5.27-47.8-11.16-68.22a4.46 4.46 0 0 0-5.59-2.95c-19 5.74-38.79 10.43-59.09 12a4.4 4.4 0 0 0-4.15 4.32v55.11a4.4 4.4 0 0 0 4.47 4.32z" fill="currentColor"></path><path d="M233.31 70.56c-15.42 8.57-29.17 24.43-41.47 46.37c-1.91 3.41-4.19 8.11-6 11.67a4.31 4.31 0 0 0 2.76 6a225.42 225.42 0 0 0 46.54 9.17a4.43 4.43 0 0 0 4.91-4.29V74.26a4.49 4.49 0 0 0-6.74-3.7z" fill="currentColor"></path><path d="M235.92 176.26c-20.3-1.55-40.11-6.24-59.09-12a4.46 4.46 0 0 0-5.59 2.95c-5.89 20.42-9.68 45.45-11.16 68.22a4.39 4.39 0 0 0 4.46 4.58h71.06a4.4 4.4 0 0 0 4.47-4.34v-55.09a4.4 4.4 0 0 0-4.15-4.32z" fill="currentColor"></path><path d="M414.39 97.61A224 224 0 1 0 97.61 414.39A224 224 0 1 0 414.39 97.61zM176.6 430.85a219.08 219.08 0 0 1-12.48-19.66c-2-3.69-4.84-9.26-6.73-13.13a7.29 7.29 0 0 0-10.31-3.16c-4.3 2.41-10 5.72-14.13 8.43a147.29 147.29 0 0 1-23.57-22.43a248.83 248.83 0 0 1 30.41-18.36c1.86-1 2.77-2.14 2.18-4.18a374.8 374.8 0 0 1-14.09-82.17a4.36 4.36 0 0 0-4.3-4.17H66.84a2 2 0 0 1-2-1.7A98.28 98.28 0 0 1 64 256a96.27 96.27 0 0 1 .86-14.29a2 2 0 0 1 2-1.7h56.74c2.29 0 4.17-1.32 4.29-3.63a372.71 372.71 0 0 1 14-81.83a4.36 4.36 0 0 0-2.19-5.11a260.63 260.63 0 0 1-29.84-17.9a169.82 169.82 0 0 1 23.14-22.8c4.08 2.68 9.4 5.71 13.66 8.11a7.89 7.89 0 0 0 11-3.42c1.88-3.87 4-8.18 6.06-11.88a221.93 221.93 0 0 1 12.54-19.91A185 185 0 0 1 256 64c28.94 0 55.9 7 80.53 18.46a202.23 202.23 0 0 1 12 19c2.59 4.66 5.34 10.37 7.66 15.32a4.29 4.29 0 0 0 5.92 1.94c5.38-2.91 11.21-6.26 16.34-9.63a171.36 171.36 0 0 1 23.2 23a244.89 244.89 0 0 1-29.06 17.31a4.35 4.35 0 0 0-2.18 5.12a348.68 348.68 0 0 1 13.85 81.4a4.33 4.33 0 0 0 4.3 4.12l56.62-.07a2 2 0 0 1 2 1.7a117.46 117.46 0 0 1 0 28.62a2 2 0 0 1-2 1.72h-56.67a4.35 4.35 0 0 0-4.3 4.17a367.4 367.4 0 0 1-13.87 81.3a4.45 4.45 0 0 0 2.19 5.19c5 2.59 10.57 5.48 15.37 8.42s9.55 6.08 14.13 9.34a172.73 172.73 0 0 1-23 22.93c-2.44-1.61-5.34-3.44-7.84-4.94c-1.72-1-4.89-2.77-6.65-3.76c-3.82-2.14-7.88-.54-9.79 3.4s-4.83 9.59-6.87 13.25a212.42 212.42 0 0 1-12.35 19.53C310.91 442.37 284.94 448 256 448s-54.77-5.63-79.4-17.15z" fill="currentColor"></path></svg>
                <span class="ml-2 ">{{ lang.label }}</span>
              </button>
          </div>
          </n-dropdown>
      </div>

      
     
    </div>
  </div>
</nav>


</template>
<script lang="ts">
import {ref,reactive,onMounted,watch} from "vue"
import router from "@/router"
import { useI18n } from 'vue-i18n'
import {t} from '@/plugin/i18n'

export default {
  setup(){
    const ShowMenu = ref(false)
    let showSubItem = ref(false)
    const { t } = useI18n(); // 获取 t 函数

    let options = ref( [
      {
        label: t("MenuItem.Introduction"),
        key: '1',
        val:''
      },
      {
        label: t("MenuItem.Member"),
        key: "2",
        val:''
      },
      
    ])
      const isMobileExpand = ref(true)
      const onExpand = () =>{
        isMobileExpand.value = !isMobileExpand.value
        onTop();
      }

    const optionsLang = reactive( [
        {
          label: '中文',
          key: '1',
          val:'zh-TW'
        },
        {
          label: 'English',
          key: "2",
          val:'en-US'
        },
        
      ]);
    
    let lang = ref( {
          label: '中文',
        })

    const onFooter = () =>{
      const child = document.querySelector('#content')
      window.scrollTo({
        top:child?.scrollHeight,
        behavior: "smooth"
      })
    }

    const onNews = async() =>{
      await router.push({ path: '/', replace: true })
      const child = document.querySelector('#title')
      if(child){
        window.scrollTo({
          top:child?.scrollHeight,
          behavior: "smooth"
        })
      }else{
        window.scrollTo({
          top:1000,
          behavior: "smooth"
        })
      }
    }

    const onShowItem = () =>{
      showSubItem.value != showSubItem.value;
    }

    const { locale } = useI18n()

    const handleChangeLanguage = (e:string) => {
      const temp = optionsLang.find(item => item.key == e)
      if(temp){
        lang.value.label = temp.label
        locale.value = temp.val
      }
      options.value[0].label =  t("MenuItem.Introduction")
      options.value[1].label =  t("MenuItem.Member")
      // 
     
    }
    const onTop = async()=>{
      await window.scrollTo({
          top:10,
          behavior: "smooth"
        })
    }
   
    
    return {
        options,
        handleSelect (key: string | number) {
          
          if(key==2){
            router.push({ path: '/member', replace: true })
          }else{
            router.push({ path: '/about', replace: true })
          }
          onTop();
        },
        onExpand,
        isMobileExpand,
        onFooter,
        onNews,
        ShowMenu,
        showSubItem,
        onShowItem,
        handleChangeLanguage,
        optionsLang,
        lang,
        onTop
  }
}
}

</script>